<script>
// import { onMount } from 'svelte';
 import Tag from "./Tag.svelte";
 import Picker from "./Picker.svelte";
// import ProductSelect from './ProductSelect.svelte'
// let notes;
 export let products=window.products || [];
 export let defaultsku = window.sku || "";
 export let allAFs=[];
 export let number;
 let name = "item_" + number;
// console.log("initial prodicts ", window.products, products);
 export let af = {
     title: "",
     notes: "",
     speakers: "",
     tags: [],
     url: "",
     sku: defaultsku,
     daq: false,
     verbatim: false,
     itemid: "",
     cutaudio: false,
     cuts: { start: "", end: "" },
     captions: false,
     timestamps: false,
     itemnumber: name
 };
 //console.log();
//  $: console.log(`name ${name} aftags ${af.url}`, af.tags, af, defaultsku,products);
  if (af.sku == "" ){af.sku=defaultsku;}
</script>

<style>
    #sku {border: 1px solid black; background-color: unset;}
 .oneaudio * {box-sizing: border-box; }
 .daqmessage{
     overflow-wrap: break-word;
     max-width: 350px;}
 .tags {
     overflow: auto;
 }
 .oneaudio {
     border: 1px solid #fdbe0e;
     padding: 1em;
     margin-top: 2em;
 }

 .tags {
     display: block;
     clear: both;
 }

 .help {
     float: right;
     font-size: 8px;
     font-weight: lighter;
     margin-left: 10px;
     clear: both;
     display: block;
     width: 100%;
     text-align: right;
     margin-bottom: -5px;
     margin-top: 5px;
 }
 .optionshr {
     width: 50%;
     margin: 2em auto;
 }

 .oneaudio {
     display: flex;
     flex-wrap: wrap;
     overflow: auto;
 }
 .oneaudio > div {
     min-width: 350px;
 }
 .oneaudio .audio {
     width: 60%;
     padding-right: 1.5em;
 }
 .cutaudio {
     margin-top: 0.5em;
 }
 .options h4 { margin-bottom: 3em;}
.btn {border-radius: 4px;}
 @media (max-width: 600px) {
     .oneaudio {padding: .25em;}

 }

 @media (max-width: 300px) {
     .oneaudio {padding: 1em .05em;}

 }

 @media (max-width: 800px) {
     .daqmessage{ max-width: 100%;}
     .oneaudio > div{ min-width: initial;}     
     .oneaudio .audio {
         width: 100%;
         padding-right: 0em;
         
     }  
     .options {
         width: 100%;
         font-size: 12pt;
     }
     .help{margin-bottom: 0px;}


 }

 @media (max-width: 1000px) {
     .oneaudio > div {
         min-width: initial;
     }
     .oneaudio .audio {
         width:100%;
         padding-right: 0;
     }
}
     
     @media (max-width: 1395px) {
         .oneaudio > div {
             min-width: initial;
         }
         .oneaudio .audio {
             max-width: 500px;
         }

         .options h4 {
             margin: 3em 0 1em 0;
         }
     }
</style>



<div class="oneaudio">
    <div class="audio">
        <Picker bind:af={af} name={name} bind:allAFs={allAFs}/>
        <div class="form-group">
            <label for="title">Title</label>
            <input class="form-control" type="text" id="title" name="{name}.title" bind:value="{af.title}" placeholder="Name of the transcript" autocomplete="ON"/>
        </div>


        <div class="form-group">
            <label for="speaker">Speakers</label>
            <input class="form-control speaker"
                   type="text" id="speaker" 
                   name="{name}.speaker"
                   bind:value="{af.speaker}" 
                   placeholder="Enter speakers' names separated by commas."
	           autocomplete="ON"/>
        </div>



        <div class="form-group">
            <label for="notes">Notes</label>
            <textarea class="form-control speaker text notes" id="notes" name="{name}.notes" rows="5" maxlength="1000" width="100%"
		      placeholder="Any notes to pass onto the transcribers? You may want to include the title of your show, useful websites, unusual words, keywords, acronyms, and the names of the speakers. "
		      bind:value={af.notes}></textarea>
        </div>


        <div class="form-group tags">
            <label for="tags">Tags</label>
            <div>
	        <Tag name="{name}.tags" bind:aftags={af.tags} checked="" value="Academic" />
                <Tag name="{name}.tags" bind:aftags={af.tags} checked="" value="Audience Participation" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked=""  value="Dictation" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked=""  value="Focus Group" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked=""  value="Interview " />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked="" value="Lecture/Speech" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked="" value="Medical" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked="" value="Oral History" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked="" value="Panel / Round Table" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked="" value="Professionally Produced" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked="" value="Religious" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked="" value="Research for article/book" />
                <Tag name="{name}.tags" bind:aftags={af.tags}  checked="" value="Technical" />	 
            </div>
        </div>
    </div>

    <hr>
    
    <div class="options">
        <h4 >Options</h4>



        {#if products.length }
        <div class="form-group">
            <label for="Product">Product</label>

            <select class="form-control product"
                    type="text" id="sku" 
                    name="{name}.sku"
                    bind:value="{af.sku}"               
	    >       
                {#each products as product}
                
                {#if  (af.sku  && af.sku  == product.sku)  || (!af.sku && product.sku == defaultsku)}
                <option value="{product.sku}" selected>{product.name} ({product.price})</option>
                {:else}
                <option value="{product.sku}">{product.name} ({product.price})</option>
                {/if}
                {/each}
            </select>        
        </div>


        <br/>

        
        {/if}
        <a href="https://castingwords.com/support/transcription-faq.html#difficultquality" target="_new" class="help">Is my audio difficult?</a>  
    <input type="checkbox" bind:checked={af.daq}  name="{name}.bad_audio_quality" value="bad_audio_quality" class="bad_audio_quality"> 
    <label for="{name}.bad_audio_quality">Difficult audio quality ($0.75/minute)
    </label> 
    <div  class="daqmessage {af.daq ? '' : 'hidden'}">
      <b>Note:
      </b> We do not guarantee delivery times on difficult audio orders. Turnaround may take longer for particularly difficult audio. 
    </div> 
    <br>
    <a href="https://castingwords.com/support/transcription-faq.html#verbatim" target="_new" class="help">What does this mean?
    </a> 
    <input type="checkbox" bind:checked={af.verbatim} name="{name}.verbatim" value="verbatim"> 
    <label for="{name}.verbatim">Fully Verbatim ($0.30/minute)           
    </label> 
    <br>    
 <input bind:checked={af.cutaudio} type="checkbox" 
  name="{name}.cutaudio" 
 value="cutaudio" 
        class="cutaudio"
 > 
 <label for="{name}.cutaudio">Trim Audio ($1.00 surcharge)</label> 
 <div class="cutaudiotimes {af.cutaudio ? '' : 'hidden'}">Start At:  
 <input bind:value={af.cuts.start} type="text" id="{name}.cutaudiostart" name="{name}.cutaudiostart" placeholder="mm:ss">  
 <span style="font-size: 8pt; color; #aaa;">mm:ss or hh:mm:ss</span>
 <br>End At:&nbsp;
 <input bind:value={af.cuts.end} type="text"  name="{name}.cutaudioend" placeholder="mm:ss"> 
 <span style="font-size: 8pt; color; #aaa;">mm:ss  or hh:mm:ss</span><br> 
 <span style="font-size: 8pt; color; #aaa;">If left blank, Start At defaults to 00:00, and End At defaults to the end of the file.</span> 
 </div>

    <hr class="optionshr"> 
    <input type="radio"  name="{name}.timestamps"   on:change={() => {af.timestamps = ""}} value="" checked={af.timestamps == ""}> 
    <label for="{name}.timestamps">No Timing
    </label> 
    <br>  
    <a href="https://castingwords.com/support/transcription-faq.html#timestamps" target="_new" class="help">What are timestamps?
    </a> 
    <input type="radio"  name="{name}.timestamps"  on:change={() => { af.timestamps = "timestamps"}}  checked={af.timestamps == "timestamps"} value="timestamps"> 
    <label for="{name}.timestamps">Timestamps 
    </label> 
    <br> 
    <a href="/support/subtitles-and-captions-faq.html" target="_new" class="help">What are subtitles?
    </a> 
    <input type="radio"  name="{name}.timestamps"   on:change={() => {af.timestamps = "captions"}} checked={af.timestamps == "captions"} value="captions"> 
    <label for="{name}.captions">Subtitles         
    </label> 
    <br>  


  </div>
</div>
